<script setup lang="ts">
// The new device receiving message history from the device that linked it (HRTH-202).
import { stopTransfer, transfer, transferRunning } from '../lib/transfer'

const percent = () => (transfer.total ? Math.floor((100 * transfer.done) / transfer.total) : 0)
</script>

<template>
  <div
    v-if="transfer.role === 'receive' && transfer.phase !== 'stopped'"
    class="mono fixed top-4 right-4 z-50 max-w-sm border border-ink bg-ink px-4 py-3 text-[12px] text-paper shadow-[0_8px_24px_rgba(0,0,0,0.4)]"
    role="status"
    aria-live="polite"
    data-testid="transfer-receive"
  >
    <p v-if="transfer.phase === 'waiting'">Waiting for your message history from your other device…</p>
    <p v-else-if="transferRunning()">
      Receiving your message history… {{ percent() }}%
      <template v-if="transfer.attachments"> · {{ transfer.attachments }} attachment{{ transfer.attachments === 1 ? '' : 's' }}</template>
    </p>
    <p v-else-if="transfer.phase === 'done'">
      Your message history is here ({{ transfer.messages }} message{{ transfer.messages === 1 ? '' : 's' }}<template
        v-if="transfer.attachments">, {{ transfer.attachments }} attachment{{ transfer.attachments === 1 ? '' : 's' }}</template>).
    </p>
    <p v-else>{{ transfer.error }}</p>
    <div class="mt-2 flex justify-end">
      <button v-if="transferRunning()" class="underline" @click="stopTransfer">Stop</button>
      <button v-else class="underline" data-testid="transfer-dismiss" @click="transfer.role = null">OK</button>
    </div>
  </div>
</template>
